import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const dcbloxLogo = `${CDN_URL}common/dcblox-logo-lg.svg`;

const LibraryNavStyle = styled.div`
	height: 100vh;
	body {
		background: black;
	}

	p {
		font-size: 1.1em;
		font-weight: 300;
		line-height: 1.7em;
		color: #999;
	}

	a,
	a:hover,
	a:focus {
		color: inherit;
		text-decoration: none;
		transition: all 0.3s;
	}

	.navbar {
		padding: 15px 10px;
		background: #fff;
		border: none;
		border-radius: 0;
		margin-bottom: 40px;
		box-shadow: 1px 1px 3px ${props => props.theme.boxShadow};
	}

	.navbar-btn {
		box-shadow: none;
		outline: none !important;
		border: none;
	}

	.line {
		width: 100%;
		height: 1px;
		border-bottom: 1px dashed #ddd;
	}

	.wrapper {
		display: flex;
		width: 100%;
		height: 100vh;
		align-items: stretch;
	}

	#sidebar {
		min-width: 250px;
		max-width: 250px;
		background: black;
		color: #fff;
		transition: all 0.3s;
	}

	#sidebar.active {
		margin-left: -250px;
	}

	#sidebar .sidebar-header {
		padding: 20px;
		background: black;
	}

	#sidebar ul.components {
		padding: 20px 0px;
		border-bottom: 1px solid #47748b;
	}

	#sidebar ul p {
		padding: 10px;
		font-size: 15px;
		display: block;
		color: #fff;
	}

	#sidebar ul li a {
		padding: 10px;
		font-size: 1.1em;
		display: block;
	}

	#sidebar ul li a:hover {
		color: #fff;
		background: #318fb5;
	}

	#sidebar ul li.active > a,
	a[aria-expanded='true'] {
		color: #fff;
		background: #318fb5;
	}

	a[data-toggle='collapse'] {
		position: relative;
	}

	.dropdown-toggle::after {
		display: block;
		position: absolute;
		top: 50%;
		right: 20px;
		transform: translateY(-50%);
	}

	ul ul a {
		font-size: 0.9em !important;
		padding-left: 30px !important;
		background: #318fb5;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const LibraryNav = () => {
	return (
		<LibraryNavStyle>
			<div class='wrapper'>
				<nav id='sidebar'>
					<div class='sidebar-header'>
						<img src={dcbloxLogo} />
					</div>
					<ul class='list-unstyled components body10'>
						<p className='heading70'>Component Library</p>
						<li>
							{' '}
							<Link to=''>Home</Link>
						</li>
						<li>
							<Link to='fonts'>Fonts</Link>
						</li>

						<li>
							<Link to='colors'>Colors</Link>
						</li>
						<li>
							<Link to='buttons'>Buttons</Link>
						</li>
						<li>
							<Link to='modals'>Modals</Link>
						</li>
					</ul>
				</nav>
			</div>
		</LibraryNavStyle>
	);
};
